/**
 * Polyfill for the Object.assign method
 *
 * @method Object.assign
 * @param
 * @returns
 */
Object.assign = Object.assign || function assign(target, varArgs) {
  if (!target) { // TypeError if undefined or null
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var to = Object(target);

  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];

    if (nextSource != null) { // Skip over if undefined or null
      for (var nextKey in nextSource) {
        // Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey];
        }
      }
    }
  }

  return to;
};


/**
 * Polyfill for the Array.find method
 *
 * @method Array.find
 * @param
 * @returns
 */
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function (predicate) {
      // 1. Let O be ? ToObject(this value).
      if (!this) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];

        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }

        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}


/**
 * Polyfill for the Array.includes method
 *
 * @method Array.includes
 * @param
 * @returns
 */
Array.prototype.includes = Array.prototype.includes || function (searchElement, fromIndex) {
  if (!this) {
    throw new TypeError('Array.prototype.includes called on null or undefined');
  }

  var i = fromIndex || -1;
  var l = this.length;

  while (i++ !== l) {
    if (this[i] === searchElement) {
      return true;
    }
  }

  return false;
};


/**
 * Polyfill for the Array.isArray method
 *
 * @method Array.isArray
 * @param {Mixed} arg	Object to evaluate as an array
 * @returns {Boolean}
 */
Array.prototype.isArray = Array.prototype.isArray || function (arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};


/**
 * Polyfill for Array.forEach method
 *
 * @method Array.forEach
 * @param {Function} callback
 * @returns none
 */
Array.prototype.forEach = Array.prototype.forEach || function (callback /*, thisArg*/) {
  if (!this) {
    throw new TypeError('this is null or not defined');
  }

  var O = Object(this);
  var len = O.length >>> 0;

  if (typeof callback !== 'function') {
    throw new TypeError(callback + ' is not a function');
  }

  if (arguments.length > 1) {
    var T = arguments[1];
  }

  var k = 0;

  while (k < len) {
    if (k in O) {
      var kValue = O[k];
      callback.call(T, kValue, k, O);
    }

    k++;
  }
};


/**
 * Ensures that an object is an array and returns an array with the
 * object if it is not
 *
 * @method makeArray
 * @param {Object} obj
 * @returns {Array}
 */
Array.makeArray = function (obj) {
  return obj ? (Array.isArray(obj) ? obj : [obj]) : [];
};


/**
 * Ensures that an array only contains unique values
 * 
 * @method Array.unique
 * @returns {Array}
 */
Array.prototype.unique = Array.prototype.unique || function () {
  var j = {};

  this.forEach(function (v) {
    var typ = typeof v;
    var v = (typ === 'object') ? JSON.stringify(v) : v;

    j[v + '::' + typ] = v;
  });

  return Object.keys(j).map(function (v) {
    if (v.indexOf('::object') > -1) {
      return JSON.parse(j[v]);
    }

    return j[v];
  });
};

/**
 * Performs array.prototype.find on each array element in an array of arrays until a match is found.
 *
 * @param {function} a callback function passed to Array.prototype.find
 * @param {Array} an array of arrays
 */
function findInArrays(callback, arrays) {
  var arraysIndex = 0;
  var foundElement = undefined;

  var continueSearch = function () {
    return foundElement == undefined && arraysIndex < arrays.length;
  };

  while (continueSearch()) {
    var arrayN = arrays[arraysIndex];
    foundElement = arrayN.find(callback);
    arraysIndex++;
  }

  return foundElement;
}

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function(search, rawPos) {
      var pos = rawPos > 0 ? rawPos|0 : 0;
      return this.substring(pos, pos + search.length) === search;
    }
  });
}

module.exports.findInArrays = findInArrays;

